import get from 'lodash/get';

import { CurrencyFilter } from 'filters/vCurrency';
import { OrderTotalsLineItem } from './orderTotalsLineItem';
import { DiscountLineItems } from './discountLineItems';
import { StoreCreditLineItems } from './storeCreditLineItems';
import { getItemsTotal } from '../../../../services/cartUtils';

import template from './orderTotals.html';
import './orderTotals.scss';

export const OrderTotals = angular
    .module('checkout.components.orderSummary.orderTotals', [
        CurrencyFilter,
        OrderTotalsLineItem,
        DiscountLineItems,
        StoreCreditLineItems
    ]).component('orderTotals', {
        template,
        bindings: {
            cart: '<',
            storeCreditInfo: '<',
            appliedDiscount: '<',
            onRemovePromoClicked: '<',
            order: '<'
        },
        controller: class OrderTotalsCtrl {
            $onChanges(changesObj) {
                const cartItems = get(changesObj, 'cart.currentValue.items');
                if (cartItems) {
                    this.itemsTotal = getItemsTotal(cartItems);
                }
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/orderTotals/orderTotals.js